import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { DocumentSummaryModel } from '../../cmg-1003/models';
import { Cmg1003DocumentSummaryStore } from './document-summary.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003DocumentSummaryQuery extends Query<DocumentSummaryModel> {
  protected store: Cmg1003DocumentSummaryStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(Cmg1003DocumentSummaryStore);

    super(store);

    this.store = store;
  }
}
